import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import image_02 from "../../assets/img/no_camera-photo.png";
import applicationLogo from "../../assets/img/logos/dicelogo22.png";
import applicationLogo02 from "../../assets/img/logos/dicelogo2.png";
import axios from "axios";
import swal from "sweetalert";
import Modal from "../../components/admin/childComponents/popups/Modal";

const Navbar = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [allRecordQ, setAllRecordQ] = useState([]);
  const [btnColor, setBtnColor] = useState("airforce");
  //Fetches all Data
  const [generalData, setGeneralData] = useState({
    staffImage: null,
    admin_type: null,
    allCount: null,
    menuSize: 0,
  });

  // Open Dialogue Box
  const [dialogueState, setDialogueState] = useState({
    modalType: false,
    modalTitle: null,
    trigger: false,
    editpost: null,
    searchScript: null,
  });

  useEffect(() => {
    setGeneralData((prev) => ({
      ...prev,
      staffImage: localStorage.getItem("admin_passport"),
      admin_type: localStorage.getItem("admin_type"),
    }));
  }, []);

  const BACKEND_URL =
    process.env.REACT_APP_BACKEND_URL + generalData.staffImage;
  // console.log("###333", generalData.staffImage); //upload/admin_passports/emptyImage.jpg
  // /*
  //   I use this to display and remove the side menubar
  //   (document.getElementById doesnot work directly in react)
  // */

  const navigate = useNavigate("");
  useEffect(() => {
    mailMessage();
    axios.get("sanctum/csrf-cookie");
  }, [generalData.menuSize]);

  async function mailMessage() {
    try {
      let datasa = `?status[eq]=pending`;

      const res = await axios.get(BASE_URL + "fbdata" + datasa);

      if (res?.data?.status === 200) {
        const records = Array.isArray(res.data.allData) ? res.data.allData : [];

        setAllRecordQ(records);

        setGeneralData((prev) => ({
          ...prev,
          allCount: records.length,
        }));
      } else {
        console.log(res?.data?.validation_error);
      }
    } catch (error) {
      console.log("MAIL ERROR:", error);
    }
  }
  async function logoutSubmit(event) {
    event.preventDefault();

    await axios.get("sanctum/csrf-cookie").then((response) => {
      try {
        axios.post(BASE_URL + "logout").then((res) => {
          if (res?.data?.status === 200) {
            console.log(res.data.message);
            localStorage.removeItem("admin_passport");
            localStorage.removeItem("auth_token");
            localStorage.removeItem("admin_id");
            localStorage.removeItem("auth_name");
            localStorage.removeItem("admin_type");
            localStorage.removeItem("NumberType");
            localStorage.removeItem("debitGrandTotal");
            localStorage.removeItem("creditGrandTotal");
            localStorage.removeItem("admin_signature");
            localStorage.removeItem("newGrandTotal");
            localStorage.removeItem("grandTotal");
            localStorage.removeItem("admin_authority");
            localStorage.removeItem("admin_status");
            localStorage.removeItem("allGrandTotal");
            localStorage.removeItem("selectedSearch");
            localStorage.removeItem("encryption");

            swal("Logout Successful", res.data.message, "success");
            navigate("/logout");
          } else {
            swal("Warning", res.data.message, "warning");
          }
        });
      } catch (error) {
        swal("Oops!", "Logout Failed", "error");
      }
    });

    setTimeout(function () {
      setGeneralData((prev) => ({
        ...prev,
        menuSize: 1,
      }));
    }, 3000);
  }

  async function readData(event, posts) {
    event.preventDefault();

    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalRead",
      modalTitle: "READ MAIL",
      trigger: true,
      editpost: posts,
    }));
    setBtnColor("success");
  }

  // Clean the Form
  const formCleanner = () => {
    setDialogueState((prev) => ({
      ...prev,
      modalType: false,
      modalTitle: null,
      trigger: false,
      editpost: null,
      searchScript: null,
    }));

    //fetchfbdata();
  };

  function reloadChart() {
    mailMessage();
  }

  return (
    <>
      {/* modal Type, Title of the Modal Box, triger the modal, convay all the data inputs to be edithed to child */}
      <Modal
        modalType={dialogueState.modalType}
        titles={dialogueState.modalTitle}
        trigger={dialogueState.trigger}
        editpost={dialogueState.editpost}
        formCleanner={formCleanner}
        reloadChart={reloadChart}
        searchDate={dialogueState.searchDates}
        searchScript={dialogueState.searchScript}
        btnColor={btnColor}
      />
      {/* START HEADER*/}
      <header className="header" id="header">
        <div className="page-brand">
          <Link className="link" to="/admin/dashboard">
            <span className="brand">
              <span className="brand-tip pb-3">
                <img
                  src={applicationLogo}
                  alt=""
                  style={{ width: "90%", height: "auto" }}
                />
              </span>
            </span>
            <span className="brand-mini">
              <img
                src={applicationLogo02}
                alt=""
                style={{ width: "70%", height: "auto", marginLeft: "5%" }}
              />
            </span>
          </Link>
        </div>
        <div className="flexbox flex-1">
          {/* START TOP-LEFT TOOLBAR*/}
          <ul className="nav navbar-toolbar">
            <li>
              <Link className="nav-link sidebar-toggler js-sidebar-toggler">
                <i className="ti-menu" />
              </Link>
            </li>

            <li>
              <form className="navbar-search responsiveIt" action="#">
                <div className="rel">
                  <span className="search-icon">
                    <i className="ti-search" />
                  </span>
                  <input
                    className="form-control"
                    placeholder="Search here..."
                  />
                </div>
              </form>
            </li>
          </ul>
          {/* END TOP-LEFT TOOLBAR*/}
          {/* START TOP-RIGHT TOOLBAR*/}
          <ul className="nav navbar-toolbar">
            <li className="dropdown dropdown-inbox responsiveIt">
              <Link className="nav-link dropdown-toggle" data-toggle="dropdown">
                <i className="fa fa-envelope-o" />
                <span
                  className="position-absolute translate-middle badge bg-danger"
                  style={{ borderRadius: "100%" }}
                >
                  {generalData.allCount}
                </span>
              </Link>
              <ul className="dropdown-menu dropdown-menu-right dropdown-menu-media">
                <li className="dropdown-menu-header ">
                  <div>
                    <span>
                      <strong>{generalData.allCount} New</strong> Messages
                    </span>
                    <Link className="pull-right" to="/admin/quotemessages">
                      view all
                    </Link>
                  </div>
                </li>
                <li
                  className="list-group list-group-divider scroller"
                  data-height="240px"
                  data-color="#71808f"
                >
                  <div>
                    {allRecordQ.map((allRecord, index) => {
                      return (
                        index < 4 &&
                        allRecord.trackId && (
                          <Link
                            onClick={(event) => readData(event, allRecord)}
                            data-toggle="modal"
                            data-target="#exampleModal"
                            to=""
                            className="list-group-item"
                          >
                            <div className="media">
                              <div className="media-img">
                                <img src={image_02} width={40} alt="" />
                              </div>
                              <div className="media-body">
                                <div className="font-strong"> </div>
                                {allRecord.names}
                                <small className="text-muted float-right">
                                  Just now
                                </small>
                                <div className="font-13">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: allRecord?.subject
                                        ? allRecord.subject.substring(0, 50) +
                                          "..."
                                        : "",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </Link>
                        )
                      );
                    })}
                  </div>
                </li>
              </ul>
            </li>

            <li className="dropdown dropdown-user">
              <Link
                className="nav-link dropdown-toggle link"
                data-toggle="dropdown"
              >
                <img
                  src={BACKEND_URL}
                  alt=""
                  width="30"
                  height="30"
                  className="rounded-circle me-3"
                  style={{ border: "white 2px solid" }}
                />
                <span />
                {generalData.admin_type}
                <i className="m-l-5" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right">
                <Link className="dropdown-item" to="admin/profile">
                  <i className="fa fa-user" />
                  Profile
                </Link>
                <Link className="dropdown-item" to="admin/settings">
                  <i className="fa fa-cog" />
                  Settings
                </Link>
                <li className="dropdown-divider" />
                <Link className="dropdown-item" onClick={logoutSubmit}>
                  <i className="fa fa-power-off" />
                  Logout
                </Link>
              </ul>
            </li>
          </ul>
          {/* END TOP-RIGHT TOOLBAR*/}
        </div>
      </header>
      {/* END HEADER*/}
    </>
  );
};
export default Navbar;
